import React from 'react';

/**
 * @param {{
 *   label: string,
 *   soundUrl: string,
 *   className?: string
 * }} param
 * @returns {React.ReactElement}
 */
export default function PlaySoundButton({ label = 'Play audio', soundUrl, className }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '2rem 0',
      }}
      className={className}
    >
      {label && <div style={{ marginRight: '1rem' }}>{label}</div>}
      <audio controls>
        <source src={soundUrl} type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
}
